module.exports = __webpack_public_path__ + "img/door.c227f712.svg";